import { css } from '@emotion/css';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { ButtonBase, Chip, Typography } from '@material-ui/core';

import { FlexContainer } from '../../layout/Flex';

const Container = styled(FlexContainer)((p) => ({
  '#icon': {
    display: 'block'
  },
  '#hovericon': {
    display: 'none'
  },

  ':hover': {
    '#icon': {
      display: 'none'
    },
    '#hovericon': {
      display: 'block'
    }
  }
}));

export const ChipWithAction = ({
  label,
  color,
  backgroundColor,
  icon,
  hoverIcon,
  onClick,
  boxShadow,
  size = 'small'
}: {
  label: React.ReactNode;
  color: string;
  backgroundColor: string;
  icon?: React.ReactNode;
  hoverIcon?: React.ReactNode;
  onClick: () => void;
  boxShadow?: string;
  // 'medium' renders a taller pill (~40px) with body-sized text, so the filter
  // can sit at the same scale as adjacent search/action controls. Defaults to
  // 'small' so existing chip consumers are unaffected.
  size?: 'small' | 'medium';
}) => {
  const theme = useTheme();
  const isMedium = size === 'medium';
  const chipStyle = {
    root: css({
      color: `${color} !important`,
      backgroundColor: `${backgroundColor} !important`,
      fontWeight: theme.typography.fontWeightMedium,
      boxShadow,
      // !important beats MUI v4's JSS .MuiChip-root height/radius (injected after
      // this emotion class), matching the color/background overrides above.
      ...(isMedium
        ? {
            height: '40px !important',
            borderRadius: '20px !important',
            padding: `0 ${theme.spacing(1.5)}px !important`
          }
        : {}),
      ':hover': {
        cursor: 'pointer'
      }
    })
  };

  return (
    <ButtonBase onClick={onClick}>
      <Chip
        label={
          <Container justifyContent="center" alignItems="center">
            <Typography variant={isMedium ? 'body1' : 'caption'} color="inherit">
              {label}
            </Typography>
            <div id="icon">{icon}</div>
            <div id="hovericon">{hoverIcon || icon}</div>
          </Container>
        }
        size={isMedium ? 'medium' : 'small'}
        classes={chipStyle}
      />
    </ButtonBase>
  );
};
